// extracted by mini-css-extract-plugin
export default {"container":"close_container__3i3UM","icon":"close_icon__140-k"};